import React from 'react';
import { Button as ButtonAntd } from 'antd';
const Button = ({ variant = 'default', title, size = 'middle', className, ...restProps }) => {
    return (React.createElement(ButtonAntd, { title: title, size: size, ...restProps, className: `button variant-${variant} size-${size} ${className}` }));
};
export default Button;
